var map = {
	"./amazon/prodImg.png": 1977,
	"./apple/prodImg.png": 8123,
	"./ebay/prodImg.png": 4770,
	"./googleplay/prodImg.png": 398,
	"./netflix/prodImg.png": 863,
	"./playstation/prodImg.png": 3517,
	"./steam/prodImg.png": 71,
	"./xbox/prodImg.png": 2222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4154;